import React, { FC } from 'react'

import { Spinner, SpinnerSizes } from '@inno-ui/spinner'
import cn from 'classnames'

import styles from './ContentWrapper.module.scss'
import { ContentWrapperProps } from './ContentWrapper.types'

export const ContentWrapper: FC<ContentWrapperProps> = ({
  children,
  isLoading
}) => {
  return (
    <div
      className={cn(styles.contentWrapper, {
        [styles.loading]: isLoading
      })}
    >
      {isLoading ? <Spinner size={SpinnerSizes.XL} /> : children}
    </div>
  )
}
